import request from '@/utils/request'

// 查询销售预测列表
export function getWorkSearch (query) {
    return request({
        url: `/scp/scpProductionScheduling/workSearch`,
        method: 'get',
        params: query
    })
}

// 保存工单修改信息
export function saveWork (data) {
    return request({
        url: `/scp/scpProductionScheduling/worksave`,
        method: 'post',
        data: data
    })
}

// 提交调整重算
export function submitAdjustedRecalculation (data) {
    return request({
        url: `/scp/scpProductionScheduling/adjust?orgNo=${data.orgNo}`,
        method: 'post',
        data: data.map
    })
}

// 排产工作台列表查询(左下)
export function worklistSearch (query) {
    return request({
        url: `/scp/scpProductionScheduling/worklistSearch`,
        method: 'get',
        params: query
    })
}

// 排产工作台列表查询(右下)
export function workOtherSupplierlistSearch (query) {
    return request({
        url: `/scp/scpProductionScheduling/workOtherSupplierlistSearch`,
        method: 'get',
        params: query
    })
}

// 查询有权限的组织
export function getSystemInventOrgAll (query) {
  return request({
    url: `/system/user/inventOrgAll`,
    method: 'get',
    params: query
  })
}

// 产线产能负荷情况
export function lineCnSearch (query) {
    return request({
        url: `/scp/scpProductionScheduling/lineCnSearch`,
        method: 'get',
        params: query
    })
}

// 供应商当天负荷
export function lineVendorSearch (query) {
    return request({
        url: `/scp/scpProductionScheduling/lineVendorSearch`,
        method: 'get',
        params: query
    })
}

// 当天产能产线负荷情况
export function lineCnSearchDay (query) {
    return request({
        url: `/scp/scpProductionScheduling/lineCnSearchDay`,
        method: 'get',
        params: query
    })
}

// 排产工作台负荷查询
export function workLoadSearch (query) {
    return request({
        url: `/scp/scpProductionScheduling/workLoadSearch`,
        method: 'get',
        params: query
    })
}

// 当天产能工序负荷情况
export function operationCnSearchDay (query) {
    return request({
        url: `/scp/scpProductionScheduling/operationCnSearchDay`,
        method: 'get',
        params: query
    })
}

// 工序产能负荷情况
export function operationCnSearch (query) {
    return request({
        url: `/scp/scpProductionScheduling/operationCnSearch`,
        method: 'get',
        params: query
    })
}

export function productionSchedulingPc (data) {
    return request({
        url: `/scp/scpProductionScheduling/pc`,
        method: 'post',
        data: data
    })
}

export function productionSchedulingPublish (query) {
    return request({
        url: `/scp/scpProductionScheduling/publish`,
        method: 'get',
        params: query
    })
}

// 供应商找库存组织
export function getFindOrgBySupplierCode (query) {
  return request({
    url: `/scp/scpProductionScheduling/findOrgBySupplierCode`,
    method: 'get',
    params: query
  })
}

export function getProdLineByVendor (query) {
    return request({
        url: `/scp/scpProductionScheduling/getProdLineByVendor`,
        method: 'get',
        params: query
    })
}

// 根据组织查产品线
export function getProdLineByOrg (query) {
  return request({
    url: `/scp/scpProductionScheduling/getProdLineByOrg`,
    method: 'get',
    params: query
  })
}

// 撤销工单
export function revokeWorkOrders () {
    return request({
        url: `/scp/scpProductionScheduling/revokeWorkOrders`,
        method: 'put'
    })
}
